import React, { useState, useEffect } from 'react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setIsOpen(false);
  };

  return (
    <nav style={{...styles.nav, ...(scrolled ? styles.navScrolled : {})}}>
      <div style={styles.container}>
        <div style={styles.logoContainer}>
          <span style={styles.logoIcon}>🍽️</span>
          <span style={styles.logo}>Delicious</span>
        </div>
        
        <button 
          style={styles.hamburger} 
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Menu"
        >
          <span style={{...styles.bar, ...(isOpen ? styles.barOpen1 : {})}}></span>
          <span style={{...styles.bar, ...(isOpen ? styles.barOpen2 : {})}}></span>
          <span style={{...styles.bar, ...(isOpen ? styles.barOpen3 : {})}}></span>
        </button>

        <ul style={{...styles.menu, ...(isOpen ? styles.menuOpen : {})}}>
          <li style={styles.menuItem}><a style={styles.link} onClick={() => scrollToSection('hero')}>Home</a></li>
          <li style={styles.menuItem}><a style={styles.link} onClick={() => scrollToSection('about')}>About</a></li>
          <li style={styles.menuItem}><a style={styles.link} onClick={() => scrollToSection('menu')}>Menu</a></li>
          <li style={styles.menuItem}><a style={styles.link} onClick={() => scrollToSection('services')}>Services</a></li>
          <li style={styles.menuItem}><a style={styles.link} onClick={() => scrollToSection('contact')}>Contact</a></li>
          <li style={styles.menuItem}>
            <button style={styles.bookButton}>Book Table</button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

const styles = {
  nav: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    position: 'fixed',
    width: '100%',
    top: 0,
    zIndex: 1000,
    transition: 'all 0.3s ease',
    borderBottom: '1px solid rgba(139, 46, 59, 0.1)',
  },
  navScrolled: {
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '1.2rem 2rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  logoIcon: {
    fontSize: '1.8rem',
  },
  logo: {
    fontSize: '1.8rem',
    fontWeight: '700',
    color: 'var(--maroon)',
    letterSpacing: '-0.5px',
  },
  hamburger: {
    display: 'none',
    flexDirection: 'column',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '0.5rem',
    zIndex: 1001,
  },
  bar: {
    width: '28px',
    height: '3px',
    backgroundColor: 'var(--maroon)',
    margin: '4px 0',
    display: 'block',
    transition: 'all 0.3s ease',
    borderRadius: '3px',
  },
  barOpen1: {
    transform: 'rotate(45deg) translate(8px, 8px)',
  },
  barOpen2: {
    opacity: 0,
  },
  barOpen3: {
    transform: 'rotate(-45deg) translate(8px, -8px)',
  },
  menu: {
    display: 'flex',
    listStyle: 'none',
    gap: '2.5rem',
    alignItems: 'center',
  },
  menuOpen: {
    display: 'flex',
  },
  menuItem: {
    cursor: 'pointer',
  },
  link: {
    textDecoration: 'none',
    color: 'var(--dark)',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
    fontSize: '0.95rem',
    position: 'relative',
    padding: '0.5rem 0',
  },
  bookButton: {
    backgroundColor: 'var(--maroon)',
    color: 'var(--white)',
    padding: '0.75rem 1.8rem',
    border: 'none',
    borderRadius: '25px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '0.95rem',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 15px rgba(139, 46, 59, 0.2)',
  },
};

export default Navbar;